import { HostListener, Component, OnInit, DoCheck, ViewChild, Input, AfterViewInit, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestsService } from '../../Services/Tests/TestsService';
import { LoginService } from '../../Services/GlobalServices/login.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../Services/Alert/Alert.service';
import { isNullOrUndefined } from 'util';
import { TestdetailsComponent } from '../testdetails/testdetails.component';
import { BuyerTest, BuyerUserDetails, Questions, QuestionStatus, TestConferenceReviews, TestMode, TestReviews, TestStatus, TestViewModel, Test_Questions, Test_QuestionsNEW, Test_QuestionsOptions, TestSuiteDetailsDTO, TestSuite } from '../../../Models/Tests/tests.models';
import { SubscriptionService } from '../../Services/Subscription/SubscriptionService';
import { UserService } from '../../Services/User/UserService';
import { UserDetail } from '../../../Models/UserProfile/userprofile.models';
import { Observable, Observer, fromEvent, merge, of, throwError } from 'rxjs';
import { findIndex, map, catchError  } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoginComponent } from '../../Authentication/login/login.component';
import { CommentDTO, Comment, UserCommentVote, UsersCommentReport} from '../../../Models/InterviewQuestions/interviewquestions.model';
import { InterviewquestionsService } from '../../Services/InterviewQuestions/interviewquestions.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
declare var $: any;
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss']
})
@Pipe({
  name: 'SafePipe'
})
export class ExamComponent implements OnInit, DoCheck, AfterViewInit, OnChanges {


  @ViewChild('reviewPopup', { static: false }) reviewPopup;
  @ViewChild('conferenceReviewPopUp', { static: false }) conferenceReviewPopUp;
  @ViewChild('paymentConfirm', { static: false }) paymentConfirm;
  @ViewChild('comment', { static: true }) commentFrm: NgForm;
  moduleId: string;
  moduleName: string;
  courseURL: string;
  thumbNailes: string;
  //@Input() amount: number;
  Comments: CommentDTO[] = [];
  ReplyList: Comment[] = [];
  userCommentVote: UserCommentVote = {
    PkvoterId: "",
    FkCommentId: "",
    FkQuestionId: "",
    FkuserId: "",
    Vote :0
  };
  editComment: Comment;
  isThereWhitSpace: boolean;
  totalCommentOfPages: number=0;
  currentPageIndex: number = 1;
  maxRows: number;
  stopAndStartTimer: boolean=true;
  usersCommentReport: UsersCommentReport = {
    pkReportId: "",
    fkCommentId: "",
    fkQuestionId: "",
    fkuserId: "",
    reportCount:0};
  commentId: string;
  isPlusIcon: number=0 ;
  deletecomment: Comment;
  isWhitespace: boolean;
  oldComment: string;
  totalVotesForComment: number;
  isVisible: boolean= false;

  userresponse: any;
  isPayment: any;
  isVisiblePostComment: number;
  isVisibleEditReply: number;
  userImage: string;
  isConferenceTest: boolean = false;
  isLiveSession: boolean = false;
  PKInterviewQuestionId: string;
  currentUserID: string;
  commentedUser: string;
 



  testHelpfulness: string;
  testReview: string;

  pkTestid: string;
  PathId: string;
  replyComment: string;
  editCommentfield: string;

  currentUserId: string;
  currentUserName: string;
  currentQuestion: Test_QuestionsNEW;
  currentOptions: Test_QuestionsOptions[] = [];
  testSuiteDetails: TestSuite;
  alphabets: string;
  currentTestMode: TestMode;

  showAnswerClicked: boolean;

  //optionsChecked: string;
  isWrongOption: boolean;
  clickCount: number;
  testViewModel: TestViewModel;

  minutesCounter: number;
  secondsCounter: number;
  secondsLeft: number;
  interval: any;
  intervalNew;
  totalInterval: any;
  totalMinutesCounter: number;
  totalSecondsCounter: number;
  //isCaptcha: boolean;
  isSubscribed: boolean;
  isCheckBox: boolean;
  isPaused: boolean;
  isExamOver: boolean;
  examOver: number;
  isNextClicked: boolean;
  routerChange: number;
  isFullstop: boolean;
  needCredits: number;
  buyerTest: BuyerTest;
  //testSuite= {};
  testSuite: TestSuiteDetailsDTO;
  static id: string;
 /* windowUrls: string[] = [];*/
  Comment: string;
  totalComments: number;
  quizWithQuestionTimer: boolean;
  updateOnce: number;

  activeIds: any[] = [];
  testdetailsPath: string;
  testReviews: number;

  examLoaded: boolean;

  isDone: any;
  isMobileView: boolean;
  windowWidth: number;
  /* isTimedTest: boolean;*/
  sessionRating: number;
  trainerRating: number;
  sessionReview: boolean;
  trainerReview: boolean;
  userdetail: BuyerUserDetails;
  isOfflineOronlineStatus:boolean;
  //exam paid functionalities
  //isneedCredits: boolean;
/*  testPathId: string;*/
  timeLeft: number =10;
  totalQues: number;
  loginModelPopup: BsModalRef;
  buyingAmount;
  totalBalance;
  amount;
  itemName;
  itemId;
  wholeTestSuite;
  testQuestions: number;
  testPassPercentage: number;
  maximumMarks: number;
  isUnlock: boolean;
  isQuiz: boolean;
  role: string;
  isTimerForEachQuestion: boolean;
  samplefield: string;
  isBDTUserSubscriber: boolean=false;
  emailId: string;
  reviewForm: FormGroup;
  stars = [1, 2, 3, 4, 5];
  hoverState = 0;
  rating = 0;

  testsuiteName: string="";
  //end of the exam paid functionalities
  msg: string;
  //startDate: string = '';
  //endDate: string = '';
  //createOnline$() {
  //  return merge<boolean>(
  //    fromEvent(window, 'offline').pipe(map(() => false)),
  //    fromEvent(window, 'online').pipe(map(() => true)),
  //    new Observable((sub: Observer<boolean>) => {
  //      sub.next(navigator.onLine);
  //      sub.complete();
  //    }));
  //}
  constructor(private alertService: AlertService,
    private testService: TestsService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private router: Router,
    private modalService: NgbModal,
    private subscriptionService: SubscriptionService,
    private bsModalService: BsModalService,
    private elementRef: ElementRef,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private interviewQuestionService: InterviewquestionsService, private fb: FormBuilder
    ) {
//this.checkNetworkStatus();
    //this.router.events.subscribe((event) => {
    //  if (event instanceof NavigationStart) {
    //    if (event.url !== this.router.url && this.updateOnce === 0) {
    //      this.pauseTimer();
    //      if (this.quizWithQuestionTimer) {
    //        this.pauseTotalTimer();
    //      }
    //      this.UpdateBuyerTest(true);
    //      this.updateOnce++;
    //    }
    //  }
    //})
    //this.createOnline$().subscribe((isOnline) => {
    //  this.isOfflineOronlineStatus = isOnline;
    //  if (this.isOfflineOronlineStatus == false)
    //    this.msg = "Something went wrong, Please check your connection";
    //   console.log(this.isOfflineOronlineStatus);
    //});
  }

  transform(value: string, type: string): SafeHtml | SafeUrl {
    if (type === 'html') {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    if (type === 'url') {
      return this.sanitizer.bypassSecurityTrustUrl(value);
    }
    return value;
  }
  ngOnInit(): void {
    this.moduleName = 'Exam';
    //this.isCaptcha = false;
    this.isPayment = false;
    this.isExamOver = false;
    this.isPaused = false;
    this.isNextClicked = false;
    this.examLoaded = false;
    this.updateOnce = 0;
    this.examOver = 0;
    this.clickCount = 0;
    this.isWrongOption = false;
    this.showAnswerClicked = false;
    this.alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    this.pkTestid = this.route.snapshot.paramMap.get("PKTestId");
    this.PathId = window.localStorage.getItem("testdetailsPath");
    this.userImage = this.loginService.getUserImage();
    this.emailId = localStorage.getItem("email");
    window.scrollTo(0, 0);
    this.testdetailsPath = 'exams/' + window.localStorage.getItem("testdetailsPath");
    //this.windowUrls = window.location.href.split('/');
    //this.testPathId = this.windowUrls[3];
    this.pkTestid = this.route.snapshot.paramMap.get("PKTestId");
    this.isConferenceTest = TestdetailsComponent.isConferenceTest;
    this.isLiveSession = TestdetailsComponent.isLiveSession;
    this.role = this.loginService.getRole();
    this.currentUserId = this.loginService.getCurrentUserId();
    this.currentUserName = this.loginService.getUserName();
    this.testsuiteName = window.localStorage.getItem("testSuiteName");
    let isReloaded = window.localStorage.getItem('Reloaded')
    this.reviewForm = this.fb.group({
      rating: [null, Validators.required],
      reviewRadio: [null, Validators.required],
      testReview: ['']
    });
    if (isReloaded == 'true') {
      if (this.role == 'Student') {
        this.currentTestMode = 1;
      }
      else {
         this.currentTestMode = +window.localStorage.getItem('CurrentTestMode');
      }
      //console.log(this.currentTestMode);
    }
    else {
     if (this.role == 'Student') {
      this.currentTestMode = 1;
     }
     else {
         this.currentTestMode = TestdetailsComponent.testMode;
     }
      //console.log(this.currentTestMode);
    }

    //get TestSuite by PathId
    //this.testService.GetTestSuiteBypathidForbdtUser(this.PathId).subscribe((res) => {
    //  this.testSuiteDetails = res;
    //  localStorage.removeItem("testsuitName");
    //  localStorage.setItem("testsuitName", this.testSuiteDetails.TestSuiteTitle);
    // // this.testsuiteName = localStorage.getItem("testsuitName");
    //})

    if (!isNullOrUndefined(this.currentTestMode)) {
      this.getTestViewModelInit();

    }
    this.testService.getUserTestReview(this.currentUserId, this.pkTestid).subscribe((res) => {
      this.testReviews = res;
    })
    this.testService.isTestSubscribed(this.pkTestid, this.currentUserId).subscribe((res) => {
      this.isSubscribed = res;
    })

    //get testsuite details service call
    this.getTestSuiteDetails();
  }
  enter(starId: number) {
    this.hoverState = starId;
  }

  leave(starId: number) {
    this.hoverState = 0;
  }

  updateRating(starId: number) {
    this.rating = starId;
    this.reviewForm.patchValue({ rating: starId });
  }

  radioReview(event: any, value: string) {
    this.reviewForm.patchValue({ reviewRadio: value });
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.checkNetworkStatus();
  }
  parseQueryString(queryString: string): any {
    const urlSearchParams = new URLSearchParams(queryString);
    const params: any = {};

    urlSearchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  }
  @HostListener("window:beforeunload", ["$event"]) unloadHandler($event: Event) {

    this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
    this.UpdateBuyerTest(true);
    localStorage.setItem('Reloaded', 'true');
    localStorage.setItem('CurrentTestMode', this.currentTestMode.toString());
    let waitTime = 1500;
    new Promise<void>(resolve => setTimeout(() => resolve(), waitTime)).then((result) => { }).catch(() => { });
  }

  //let isReloaded = localStorage.getItem('Reloaded');

  //if (isReloaded == 'true') {
  //  ExamComponent.id = localStorage.getItem('id')
  //}
  //else {

  //  })
  //}

  //if (ExamComponent.id != null) {
  //  var x = JSON.parse(localStorage.getItem(ExamComponent.id));
  //  if (isReloaded == 'true' && x != null) {
  //    this.currentTestMode = x.Mode;
  //  }
  //}

  //if (x == null || x.Status == TestStatus.Completed) {
  //  this.getTestViewModelInit(this.currentTestMode, TestStatus.Completed, this.pkTestid, this.currentUserId, this.currentUserName 
  //  );
  //}
  //else {
  //  this.getTestViewModelInit(this.currentTestMode, TestStatus.InProgress, this.pkTestid, this.currentUserId, this.currentUserName );
  //}
  //shuffle questions
  shuffleArray(array: any[]): any[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  ngDoCheck(): void {
  
    if (this.testViewModel != null) {
      if (this.testViewModel.Mode != TestMode.Practice) {
        if (this.testViewModel.DefaultTimeinSecondsForEachQuestion == 0) {
          if (this.minutesCounter == 0) {
            if (this.secondsCounter == 0 && this.examOver == 0) {

              this.StartReview();
            }
          }
        }
        else {
          if (this.testViewModel.CurrentQuestionIndex < this.testViewModel.Questions.length - 1) {
            if (this.minutesCounter == 0 && this.secondsCounter == 0) {
              if (!this.isNextClicked) {
                this.testViewModel.QuestionTimeElapsedinSeconds = 0;
                this.testViewModel.CurrentQuestionIndex++;
                this.getQuestionsandOptions();
              }
            }
          }
          if (this.testViewModel.CurrentQuestionIndex == this.testViewModel.Questions.length - 1) {
            if (this.minutesCounter == 0) {
              if (this.secondsCounter == 0 && this.examOver == 0) {
                this.StartReview();
              }
            }
          }

          if (this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0) {
            if (this.totalMinutesCounter == 0) {
              if (this.totalSecondsCounter == 0) {
                this.StartReview();
              }
            }
          }
        }
      }
    }

  }
  verify() {
    this.unlockPopup();
  }
  async getTestViewModelInit() {
    this.userdetail = new BuyerUserDetails();
    this.userdetail.UserImage = this.userImage;
    this.userdetail.UserName = this.currentUserName;
    localStorage.setItem('Reloaded', 'false');
    this.testService.isTestSubscribed(this.pkTestid, this.currentUserId).subscribe((res) => {
      this.isSubscribed = res;
      //if (this.isSubscribed)
      //  this.resumeClicked();
      // console.log(this.isSubscribed);
    })


    this.testService.GetTestViewModel(this.currentTestMode, this.pkTestid, this.currentUserId, this.userdetail).subscribe((result) => {
      // if (result.IsCompleted) {
        this.testViewModel = result;
       // console.log(this.testViewModel);
        let questionStatus = this.testViewModel.Questions.some(x => x.QuestionStatus === 1);
      if (this.role == 'Student' && this.isSubscribed && !questionStatus) {
        this.testViewModel.Questions = this.shuffleArray(this.testViewModel.Questions);
      }
        //allow ques 20% logic
        this.getTotalBalance(this.currentUserId)
        this.needCredits = this.testViewModel.Questions.length * 20 / 100;
      if (this.role == "Student" && !this.isSubscribed && !this.isBDTUserSubscriber) {
        this.needCredits = 0;
      }
        this.userService.bdtUserSubscription(this.emailId, this.testsuiteName).subscribe(async (res) => {
          this.isBDTUserSubscriber = await res;
          if (this.role == "Admin") {
            this.isBDTUserSubscriber = true;
            this.isSubscribed = true;
          }
          if (!this.isSubscribed && !this.isBDTUserSubscriber) {
            for (let i = 0; i < this.testViewModel.Questions.length; i++) {
              if (i > this.needCredits) {
                this.testViewModel.Questions[i].Flag = false;
              }
              else {
                this.testViewModel.Questions[i].Flag = true;
              }
            }
          }
          else {
            for (let i = 0; i < this.testViewModel.Questions.length; i++) {
              this.testViewModel.Questions[i].Flag = true;
            }
          }
        }, (error) => {
          if (!this.isSubscribed) {
            for (let i = 0; i < this.testViewModel.Questions.length; i++) {
              if (i > this.needCredits) {
                this.testViewModel.Questions[i].Flag = false;
              }
              else {
                this.testViewModel.Questions[i].Flag = true;
              }
            }
          }
          else {
            for (let i = 0; i < this.testViewModel.Questions.length; i++) {
              this.testViewModel.Questions[i].Flag = true;
            }
          }
        });
      //this.testService.getCourseUserSubscriptions(this.emailId, this.testsuiteName, this.startDate, this.endDate).subscribe(async (res) => {
      //  this.isSubscribed = await res;
      //  if (this.isSubscribed) {
      //    // If subscribed, unlock all questions
      //    this.testViewModel.Questions.forEach(q => q.Flag = true);
      //  } else {
      //    // If not subscribed, limit based on needCredits
      //    this.testViewModel.Questions.forEach((q, i) => {
      //      q.Flag = i <= this.needCredits;
      //    });
      //  }
      //}, (error) => {
      //  if (this.isSubscribed) {
      //    this.testViewModel.Questions.forEach(q => q.Flag = true);
      //  } else {
      //    this.testViewModel.Questions.forEach((q, i) => {
      //      q.Flag = i <= this.needCredits;
      //    });
      //  }
      //});

        this.totalQues = this.testViewModel.Questions.length;
        //if (this.testViewModel.TestType != 0) {
        //  this.setCaptcha(false);
        //}
        ExamComponent.id = this.testViewModel.PKBuyerTestId;
        this.quizWithQuestionTimer = this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0 && this.testViewModel.Mode == TestMode.Quiz;
        if (this.testViewModel.Mode == TestMode.Practice) {
          if (this.testViewModel.TimeElapsedinSeconds == 0) {
            this.minutesCounter = 0;
            this.secondsCounter = 0;
          }
          else {
            this.minutesCounter = Math.trunc(this.testViewModel.TimeElapsedinSeconds / 60);
            this.secondsCounter = this.testViewModel.TimeElapsedinSeconds % 60;
          }
        }
        else {
          if (this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0) {
            this.minutesCounter = Math.trunc((this.testViewModel.DefaultTimeinSecondsForEachQuestion - this.testViewModel.QuestionTimeElapsedinSeconds) / 60);
            this.secondsCounter = Math.trunc((this.testViewModel.DefaultTimeinSecondsForEachQuestion - this.testViewModel.QuestionTimeElapsedinSeconds) % 60);
            this.totalMinutesCounter = Math.trunc((this.testViewModel.DurationinSeconds - this.testViewModel.TimeElapsedinSeconds) / 60);
            this.totalSecondsCounter = ((this.testViewModel.DurationinSeconds - this.testViewModel.TimeElapsedinSeconds) % 60);
          }
          else {
            this.minutesCounter = Math.trunc((this.testViewModel.DurationinSeconds - this.testViewModel.TimeElapsedinSeconds) / 60);
            this.secondsCounter = ((this.testViewModel.DurationinSeconds - this.testViewModel.TimeElapsedinSeconds) % 60);
          }
        }
        this.startTimer(this.testViewModel.Mode);
        if (this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0 && this.testViewModel.Mode == TestMode.Quiz) {
          this.startTotalTimer();
        }
    //  }

      this.getQuestionsandOptions();

      //this.currentQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
      //this.currentOptions = this.currentQuestion.Options;
      //localStorage.setItem(ExamComponent.id, JSON.stringify(this.testViewModel));
      //this.CheckboxOrRadioButton();
    });
  }
  //get totalbalance service call
  getTotalBalance(userId: any) {
    if (userId != null) {
      this.subscriptionService.getBalance(userId).subscribe((Res) => {
        this.totalBalance = Res;
      })
    }
  }
  //get testsuite details
  getTestSuiteDetails() {
    let userrole = this.loginService.getRole();
    this.role = userrole;
    this.testService.GetTestSuiteByPathId(this.PathId, this.currentUserId, userrole).subscribe((res) => {
      this.testSuite = res;
      this.testsuiteName = this.testSuite ? this.testSuite.TestSuiteTitle : '';
    })
  }
  startTimer(mode: TestMode) {
    if (mode == TestMode.Quiz) {
      this.interval = setInterval(() => {
        if (this.secondsCounter > 0) {
          this.secondsCounter--;
          if (this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0) {
            this.testViewModel.QuestionTimeElapsedinSeconds++;
          }
          else {
            this.testViewModel.TimeElapsedinSeconds++;
          }
        } else {
          if (Math.trunc(this.minutesCounter) > 0) {
            this.minutesCounter -= 1;
            this.secondsCounter = 60;
          }
        }
      }, 1000)
    }
    else if (mode == TestMode.Practice) {
      this.interval = setInterval(() => {
        if (this.secondsCounter < 60) {
          this.secondsCounter++;
          this.testViewModel.TimeElapsedinSeconds++;
        } else {
          this.secondsCounter = 0;
          this.minutesCounter += 1;
        }
      }, 1000)
    }
  }

  startTotalTimer() {
    this.totalInterval = setInterval(() => {
      if (this.totalSecondsCounter > 0) {
        this.totalSecondsCounter--;
        this.testViewModel.TimeElapsedinSeconds++;
      } else {
        if (Math.trunc(this.totalMinutesCounter) > 0) {
          this.totalMinutesCounter -= 1;
          this.totalSecondsCounter = 60;
        }
      }
    }, 1000)
  }

  pauseTimer() {
    this.UpdateBuyerTest(false);
    clearInterval(this.interval);
  }

  pauseTotalTimer() {
    this.UpdateBuyerTest(false);
    clearInterval(this.totalInterval);
  }

  getQuestionsandOptions(isUpdate: boolean = false) {

    if (isNullOrUndefined(this.testViewModel.PreviousQuestion)) {
      this.testViewModel.PreviousQuestion = new Questions();
    }

    if (this.testViewModel.DefaultTimeinSecondsForEachQuestion == 0) {
      this.testViewModel.QuestionTimeElapsedinSeconds = 0;
    }

    //if (this.isExamOver) {
    //  this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
    //}

    this.testService.getCurrentExamQuestion(this.testViewModel, this.isExamOver, isUpdate).subscribe((res) => {
      this.currentQuestion = res;
      //Get course link for each questions
      this.GetVidoesLinkForQues(this.currentQuestion.PKTestQuestionId);
      if (!isNullOrUndefined(this.currentQuestion.Description)) {
        this.currentOptions = this.currentQuestion.options;
        this.CheckboxOrRadioButton();
        this.examLoaded = true;
        this.isMarkedforReview();
      }
      this.PKInterviewQuestionId = this.currentQuestion.PKTestQuestionId;
      this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
    })

    this.isNextClicked = false;
    if (this.testViewModel.DefaultTimeinSecondsForEachQuestion != 0 && this.testViewModel.Mode == TestMode.Quiz) {
      this.pauseTimer();
      this.testViewModel.QuestionTimeElapsedinSeconds = 0;
      this.secondsLeft = (this.testViewModel.DefaultTimeinSecondsForEachQuestion) / 60;
      this.minutesCounter = Math.trunc(this.secondsLeft)
      this.secondsCounter = 0;
      this.startTimer(this.testViewModel.Mode);
    }
  }
  /*  if(this.isOfflineOronlineStatus == true) */
  nextClicked() {
    //if (this.isSubscribed == false && !this.isConferenceTest && !this.isLiveSession) {
    //  this.setCaptcha(true);
    //}
    this.isOfflineOronlineStatus = false;

    //Check Network is online or offline
    this.testService.checkNetworkStatus().subscribe((res) => {
       this.isOfflineOronlineStatus = res;
     // console.log(this.isOfflineOronlineStatus);
      if (this.isOfflineOronlineStatus) {
        this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
        if (!this.isExamOver) {
          this.showAnswerClicked = false;
        }
        this.activeIds = [];
        this.isNextClicked = true;
        this.testViewModel.CurrentQuestionIndex++;
        this.getQuestionsandOptions();
        if (!this.isSubscribed && !this.isBDTUserSubscriber) {
          if (this.testViewModel.CurrentQuestionIndex >= this.needCredits - 1) {
            this.unlockPopup();
          }
        }
      }
    }, (error) => {
      alert(this.alertService.warn("Please Check Internet Connection"));
    })
  }
  previousClicked() {
    //if (this.isSubscribed == false && !this.isConferenceTest && !this.isLiveSession) {
    //  this.setCaptcha(true);
    //}
    //Check Network is online or offline
    this.testService.checkNetworkStatus().subscribe((res) => {
      this.isOfflineOronlineStatus = res;
      if (this.isOfflineOronlineStatus) {
        this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
        if (!this.isExamOver) {
          this.showAnswerClicked = false;
        }
        this.activeIds = [];
        this.testViewModel.CurrentQuestionIndex--;
        this.getQuestionsandOptions();
      }
    }, (error) => {
      alert(this.alertService.warn("Please Check Internet Connection"));
    });
   
  }

  firstClicked() {
    //if (this.isSubscribed == false && !this.isConferenceTest && !this.isLiveSession) {
    //  this.setCaptcha(true);
    //}
    this.testService.checkNetworkStatus().subscribe((res) => {
      this.isOfflineOronlineStatus = res;
      if (this.isOfflineOronlineStatus) {
        this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
        if (!this.isExamOver) {
          this.showAnswerClicked = false;
        }
        this.activeIds = [];
        this.testViewModel.CurrentQuestionIndex = 0;
        this.getQuestionsandOptions();
      }
    }, (error) => {
      alert(this.alertService.warn("Please Check Internet Connection"));
    })
  }

  lastClicked() {
    this.testService.checkNetworkStatus().subscribe((res) => {
      this.isOfflineOronlineStatus = res;
      if (this.isOfflineOronlineStatus) {
        //if (this.isSubscribed == false && !this.isConferenceTest && !this.isLiveSession) {
        //  this.setCaptcha(true);
        //}
        this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
        if (!this.isExamOver) {
          this.showAnswerClicked = false;
        }
        this.activeIds = [];
        this.testViewModel.CurrentQuestionIndex = this.testViewModel.Questions.length - 1;
        this.getQuestionsandOptions();
      }
    }, (error) => {
      alert(this.alertService.warn("Please Check Internet Connection"));
    })
  }

  qnumberClicked(qindex) {
    //if (this.isSubscribed == false && !this.isConferenceTest && !this.isLiveSession) {
    //  this.setCaptcha(true);
    //}
    this.testService.checkNetworkStatus().subscribe((res) => {
      this.isOfflineOronlineStatus = res;
      if (this.isOfflineOronlineStatus) {
        if (this.isMobileView) {
          window.scrollTo(0, 0);
        }
        this.testViewModel.PreviousQuestion = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
        if (!this.isPaused && (this.testViewModel.DefaultTimeinSecondsForEachQuestion == 0 || this.testViewModel.Mode == TestMode.Practice)) {
          if (!this.isExamOver) {
            this.showAnswerClicked = false;
            this.hideAnswer(); 
          }
          this.activeIds = [];
          if (qindex != this.testViewModel.CurrentQuestionIndex) {
            this.testViewModel.CurrentQuestionIndex = qindex;
            this.getQuestionsandOptions();
            //localStorage.setItem(ExamComponent.id, JSON.stringify(this.testViewModel));
          }
        }
      }
    }, (error) => {
      alert(this.alertService.warn("Please Check Internet Connection"));
    })

  }

  showAnswer() {
    this.showAnswerClicked = true;
    this.activeIds.push('myPanel');
    this.isVisible = true;
  }

  hideAnswer() {
    this.showAnswerClicked = false;
    this.activeIds = [];
    this.isVisible = false;
  }



  CheckboxOrRadioButton() {
    let count = 0;
    for (let option of this.currentQuestion.options) {
      if (option.IsCorrect) {
        count++;
      }
    }

    if (count > 1) {
      this.isCheckBox = true;
    }
    else {
      this.isCheckBox = false;
    }
  }

  checkValue(event, option) {
    this.hideAnswer();

    let currentQuestion: Questions = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex]

    if (isNullOrUndefined(currentQuestion.SelectedOptionId)) {
      currentQuestion.SelectedOptionId = '';
    }

    if (event.target.checked) {
      if (this.currentQuestion.options.includes(option)) {
        if (!this.isCheckBox) {
          currentQuestion.SelectedOptionId = '';
          currentQuestion.SelectedOptionId = option.PKOptionId + ',';
        }
        else {
          currentQuestion.SelectedOptionId += option.PKOptionId + ',';
        }
      }
      if (currentQuestion.QuestionStatus == QuestionStatus.IsMarkedForReview || currentQuestion.QuestionStatus == QuestionStatus.MarkedandAnswered) {
        currentQuestion.QuestionStatus = QuestionStatus.MarkedandAnswered;
      }
      else {
        currentQuestion.QuestionStatus = QuestionStatus.IsAnswered;
      }
    }
    else {
      if (this.currentQuestion.options.includes(option)) {
        if (currentQuestion.SelectedOptionId.split(',').length == 2) {
          currentQuestion.SelectedOptionId = '';
          currentQuestion.QuestionStatus = QuestionStatus.None;
        }
        else {
          let currentOptionIdArray = currentQuestion.SelectedOptionId.split(',');
          if (currentOptionIdArray.length == 0) {
            currentQuestion.QuestionStatus = QuestionStatus.None;
          }
          for (let i of currentOptionIdArray) {
            if (option.PKOptionId == i) {
              let index = currentOptionIdArray.indexOf(i);
              currentOptionIdArray.splice(index, 1);
            }
          }
          currentQuestion.SelectedOptionId = currentOptionIdArray.join(',');
        }
      }
    }
  }

  isMarkedforReview() {
    if (this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex].QuestionStatus > 1)
      this.currentQuestion.isMarkedforReview = true;
  }


  markForReview(event) {
    let currentQuestion: Questions = this.testViewModel.Questions[this.testViewModel.CurrentQuestionIndex];
    if (event.target.checked) {
      if (isNullOrUndefined(currentQuestion.SelectedOptionId)) {
        currentQuestion.QuestionStatus = QuestionStatus.IsMarkedForReview;
      }
      else {
        currentQuestion.QuestionStatus = QuestionStatus.MarkedandAnswered;
      }
    }
    else {
      if (isNullOrUndefined(currentQuestion.SelectedOptionId)) {
        currentQuestion.QuestionStatus = QuestionStatus.None;
      }
      else {
        currentQuestion.QuestionStatus = QuestionStatus.IsAnswered;
      }
    }
  }

  //this is not needed!

  //checkOptions(option: OptionsViewModel): boolean {
  //  if (this.currentQuestion.SelectedOptions != null) {
  //    for (let i of this.currentQuestion.SelectedOptions) {
  //      if (i.PKOptionId == option.PKOptionId) {
  //        return true;
  //      }
  //    }
  //  }
  //  else {
  //    return false;
  //  }
  //}

  pauseClicked() {
    this.pauseTimers();
    this.isPaused = true;
  }

  pauseTimers() {
    this.pauseTimer();
    if (this.quizWithQuestionTimer) {
      this.pauseTotalTimer();
    }
  }

  resumeClicked() {
    this.isPaused = false;
    this.resumeTimers();
  }

  resumeTimers() {
    this.startTimer(this.testViewModel.Mode);
    if (this.quizWithQuestionTimer) {
      this.startTotalTimer();
    }
  }

  closeClicked() {
    this.pauseTimer();
    if (this.quizWithQuestionTimer) {
      this.pauseTotalTimer();
    }
    this.UpdateBuyerTest(true);
    this.testDetailsPage();
  }

  UpdateBuyerTest(isUpdate: boolean) {
    this.getQuestionsandOptions(isUpdate);
  }

  //Activating Finish Button only if all the Answers are Selected 
  //activeFinishButton(): boolean {
  //  let count = 0;

  //  if (!this.isFinishClicked) {
  //    if (this.testViewModel.DefaultTimeinSecondsForEachQuestion == 0 || this.testViewModel.Mode == TestMode.Practice) {
  //      for ({let i of this.testViewModel.Questions) {
  //        if (i.SelectedOptions != null && i.SelectedOptions.length >= 1) {
  //          count++;
  //        }
  //        else {
  //          count--;
  //        }
  //      }
  //      if (count == this.testViewModel.Questions.length) {
  //        return true;
  //      }
  //      else {
  //        return false;
  //      }
  //    }
  //    else {
  //      if (this.testViewModel.Mode == TestMode.Quiz) {
  //        if (this.testViewModel.CurrentQuestionIndex == this.testViewModel.Questions.length - 1) {
  //          return true;
  //        }
  //        else {
  //          return false;
  //        }
  //      }
  //    }
  //  }
  //}



  StartReview() {
    clearInterval(this.interval);
    this.minutesCounter = null;
    this.secondsCounter = null;

    if (this.quizWithQuestionTimer) {
      clearInterval(this.totalInterval);
      this.totalMinutesCounter = null;
      this.totalSecondsCounter = null;
    }
    this.testViewModel.Status = TestStatus.Completed;

    if (this.isConferenceTest) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title'
      };
      this.modalService.open(this.conferenceReviewPopUp, ngbModalOptions).result.then((result) => { result.result.then(() => { }, () => { }); });/*.catch((res) => { });*/
    }
    else {
      if (this.testReviews == 0 || isNullOrUndefined(this.testReviews)) {
        let ngbModalOptions: NgbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title'
        };
        this.modalService.open(this.reviewPopup, ngbModalOptions).result.then((result) => { result.result.then(() => { }, () => { }); }).catch((res) => { });
        this.EndExam();
      }
      else if (this.testReviews !== 0) {
        this.EndExam();
      }
    }
  }

  //radioReview(event, option: string) {
  //  if (event.target.checked) {
  //    this.testHelpfulness = option;
  //  }
  //}

  conferenceRadioReview(event, option: string, rating) {
    if (option == 'session') {
      if (event.target.checked) {
        this.sessionRating = rating;
        this.sessionReview = false;
      }
    }
    else if (option == 'trainer') {
      if (event.target.checked) {
        this.trainerRating = rating;
        this.trainerReview = false;
      }
    }
  }

  submitReview() {
   
    if (!this.rating) {
      this.alertService.warn('Please provide a rating');
      return; // Ensure return ends the execution if no rating is provided
    } else {
      this.alertService.success('Thanks for rating');
    }
    if (this.isConferenceTest) {
      if (isNullOrUndefined(this.sessionRating)) {
        this.sessionReview = true;
        return; 
      }
      if (isNullOrUndefined(this.trainerRating)) {
        this.trainerReview = true;
        return; 
      }
      let testReview: TestConferenceReviews = new TestConferenceReviews();
      testReview.ConferenceName = 'AzureA2Z Virtual Conference 2020';
      testReview.FkTestId = this.pkTestid;
      testReview.FkUserId = this.currentUserId;
      testReview.SessionRating = this.sessionRating;
      testReview.TrainerRating = this.trainerRating;
      this.testService.reviewConference(testReview).subscribe(() => {
        this.modalService.dismissAll();
        this.EndExam();
      });
    } else {
      let testReview: TestReviews = new TestReviews();
      testReview.FKUserId = this.currentUserId;
      testReview.FKUserName = this.currentUserName;
      testReview.FkTestId = this.pkTestid;
      testReview.StarRating = this.rating;
      testReview.TestHelpfulness = this.testHelpfulness;
      testReview.Review = this.testReview;
      this.testService.reviewTests(testReview).subscribe(() => {
        this.modalService.dismissAll();
        this.EndExam();
      });
    }
  }
  //clossReviewPopup() {
  //  this.modalService.dismissAll();
  //  this.EndExam();
  //}

  EndExam() {
    this.isExamOver = true;
    this.testViewModel.Status = TestStatus.Completed;
    this.examOver++;
    this.UpdateBuyerTest(true);
    if (this.isConferenceTest) {
      this.router.navigate(['exams/AzureA2ZConference/Leaderboard']);
    }
    else {
      localStorage.setItem(ExamComponent.id, JSON.stringify(this.testViewModel));
      this.router.navigate(['exams/summary', this.testViewModel.PKBuyerTestId]);
    }
    this.showAnswerClicked = true;
  }

  CheckLastCorrectOne(option: Test_QuestionsOptions): boolean {
    let values: number[] = [];
    for (let x of this.currentOptions) {
      if (x.IsCorrect) {
        values.push(this.currentOptions.indexOf(x))
      }
    }

    let maxnumber = Math.max(...values);

    if (option.PKOptionId == this.currentOptions[maxnumber].PKOptionId) {
      return true;
    }
    else {
      return false;
    }
  }

  //Right click and CTRL + C , CTRL + V 

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
    this.alertService.warn('You are not allowed to do that');
  }

  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode == 67) {
      this.alertService.warn('You are not allowed to do that');
    }

    if (($event.ctrlKey || $event.metaKey) && $event.keyCode == 86) {
      this.alertService.warn('You are not allowed to do that');
    }
  }

  testDetailsPage() {
    this.router.navigate([this.testdetailsPath]);
  }

  ngAfterViewInit(): void {
    this.OnResize();

  }


  @HostListener("window:resize")
  private OnResize() {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth <= 389) {
      this.isMobileView = true;
    }
    else {
      this.isMobileView = false;
    }
  }

  //captchaResponse(event) {
  //  this.setCaptcha(!event);
  //}

  //setCaptcha(value: boolean) {
  //  if (value == true) {
  //    this.pauseTimers();
  //  }
  //  else {
  //    this.resumeTimers();
  //  }
  //  this.isCaptcha = value;
  //}

  //getCaptchaAddsPurchases() {
  //  debugger;
  //  this.subscriptionService.getCaptchaAddsPurchases(this.currentUserId, this.pkTestid, this.moduleName).subscribe((res) => {
  //    debugger;
  //    this.isPayment = res;

  //  })
  //}
  //exam paid functionalities
  buyerConfirmation(amount, itemName, itemId?: any, wholeTestSuite?: boolean): void {
    if (this.currentUserId != null) {
      if (isNullOrUndefined(this.totalBalance)) {
        this.totalBalance = 0
      }
      if (this.totalBalance < amount) {
        var res = window.location.href.split('/');
        const queryParams = {
          item: itemName,
          amount: amount,
          testSuitePathId:res[4],
          testPathId: res[5],
          testId: res[6],
          suiteId: itemId
        };

        this.alertService.error("You do not have sufficient funds in your wallet, we're redirecting to your wallet");
        new Promise<void>(resolve => setTimeout(() => resolve(), 3000)).then(() => {
          this.router.navigate(['mywallet'], { queryParams});
        })
      }
      else {
        this.buyingAmount = amount;
        this.amount = amount;
        this.itemName = itemName;
        this.itemId = itemId;
        this.wholeTestSuite = wholeTestSuite;
        //$("#unlockPopup").modal('hide');
        this.confirmPayment();
      }
    }
    else {
      this.openModalWithComponent();
    }

  }

  isBalanceSufficient(): boolean {
    return this.totalBalance >= this.amount;
  }

  openModalWithComponent() {
    /* this is how we open a Modal Component from another component */
    this.loginModelPopup = this.bsModalService.show(LoginComponent, { class: 'modal-sm' });
  }

  unlockClicked(amount, itemName, itemId?: any, wholeTestSuite?: boolean) {
    this.modalService.dismissAll();
    this.subscriptionService.purchaseItem(this.currentUserId, amount, "Exams", itemName, itemId, this.currentUserName).subscribe((res) => {
      if (res == 1) {
        this.alertService.success('You have successfully purchased the item, Please wait while we reflect the changes');
        new Promise<void>(resolve => setTimeout(() => resolve(), 3000)).then(() => {
          this.alertService.clear();
        })
        let pkTestId;
        if (!wholeTestSuite) {
          pkTestId = itemId;
        }
        this.testService.activateTestBuyerSubscription(this.currentUserId, this.testSuite.PKTestSuiteId, pkTestId).subscribe((myRes) => {
          if (myRes == 1) {
            window.location.reload();
          }
          else {
            this.alertService.error('Something went wrong, please contact us');
          }
        })
      }
      else if (res == 0) {
        this.alertService.error('You do not have sufficient funds in your wallet, load your wallet and try again');
        new Promise<void>(resolve => setTimeout(() => resolve(), 5000)).then(() => this.router.navigate(['mywallet']));
      }
      else {
        this.alertService.info('Something went Wrong, Please Retry');
      }
    })
  }

  //unlockQuestion(itemId?: any, wholeTestSuite?: boolean) {
  //  this.testService.getCourseUserSubscription(this.currentUserId, this.testSuite.PKTestSuiteId).subscribe((res)=> {
  //    if (res == 1) {
  //      this.alertService.success('You have successfully purchased the item, Please wait while we reflect the changes');
  //      new Promise<void>(resolve => setTimeout(() => resolve(), 3000)).then(() => {
  //        this.alertService.clear();
  //      })
  //      let pkTestId;
  //      if (!wholeTestSuite) {
  //        pkTestId = itemId;
  //      }
  //      this.testService.activateTestBuyerSubscription(this.currentUserId, this.testSuite.PKTestSuiteId, pkTestId).subscribe((myRes) => {
  //        if (myRes == 1) {
  //          window.location.reload();
  //        }
  //        else {
  //          this.alertService.error('Something went wrong, please contact us');
  //        }
  //      })
  //    }
  //    else if (res == 0) {
  //      this.alertService.error('You do not have sufficient funds in your wallet, load your wallet and try again');
  //      new Promise<void>(resolve => setTimeout(() => resolve(), 5000)).then(() => this.router.navigate(['mywallet']));
  //    }
  //    else {
  //      this.alertService.info('Something went Wrong, Please Retry');
  //    }
  //  })
  //}

  cancelPayment() {
    this.modalService.dismissAll();
  }

  completePayment() {
    this.resumeClicked();
    this.unlockClicked(this.amount, this.itemName, this.itemId, this.wholeTestSuite);
    this.getTestViewModelInit();
  }
  open(content, numberofquestions, maximumMarks, object, passpercentage, defaultTimeforEachQuestion) {
    //debugger;
    this.testQuestions = numberofquestions;
    this.testPassPercentage = passpercentage;
    this.maximumMarks = maximumMarks;
    //this.isTT = isTimedTests;
    if (object == 'Unlock') {
      this.isUnlock = true;
    }
    else {
      this.isUnlock = false;
      if (object == "Quiz") {
        this.isQuiz = true
      }
      else if (object == "Practice") {
        this.isQuiz = false;
      }
    }

    if (defaultTimeforEachQuestion != 0) {
      this.isTimerForEachQuestion = true;
    }
    else {
      this.isTimerForEachQuestion = false;
    }
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {

    }).catch((res) => { });
  }

  close() {
    this.modalService.dismissAll();
  }
  //Unclock credit popup
  unlockPopup() {
    //console.log(this.role);
    if (this.role != "Admin") {
      this.pauseTimer();
      //setTimeout(function () {
      //  $("#unlockPopup").modal('show');
      //}, 600);
      this.buyerConfirmation(this.testSuite.TotalPriceInDollars, this.testSuite.TestSuiteTitle, this.testSuite.PKTestSuiteId, true)
    }
  }
  //payment confirm Popup
  confirmPayment() {
    setTimeout(function () {
      $("#confirmPayment").modal('show');
    }, 600);
  }
  get isStudent(): boolean {
    if (this.role == "Student")
      return false;
    else
      return true;
  }
  //get bdt user subscription
  getbdtUserSubscription(userName: string, testSuiteName: string) {
    this.userService.bdtUserSubscription(userName, testSuiteName).subscribe((res) => {
      this.isBDTUserSubscriber = res;
    });
  }
  //Start of Submitting Comments by User for both descriptive as well as Objective Questions
  submitComment(form?: NgForm) {
    if (isNullOrUndefined(this.Comment)) {
      return this.alertService.error('Please Enter Comment');
    }
    if (form.value.Comment.length < 2) {
      return this.alertService.error('Comment must be morethan one charecter')
    }
    let userName = this.loginService.getUserName();
    let currentUserId = this.loginService.getCurrentUserId();
    var comment = new CommentDTO();
    comment.Comment = form.value.Comment;
    comment.FKInterviewQuestionId = this.PKInterviewQuestionId;
    comment.FKCommentedBy = currentUserId;
    comment.FkCommentedUser = userName;
    comment.IsExam = true;
    if (currentUserId != null) {
      this.interviewQuestionService.AddComment(comment).subscribe((res) => {
        if (res == 1) {
          this.currentPageIndex = 1;
          this.interviewQuestionService.GetAllCommentsandVotesById(comment.FKInterviewQuestionId,this.currentPageIndex,this.role).subscribe((result) => {
            this.alertService.success('Your comment has been successfully added');
            this.Comments = result;
            const role = this.loginService.getRole();
            //if (role != "Admin") {
            //  this.Comments = this.Comments.filter(x => x.ReportCount < 4);
            //}
            for (let i = 0; i < this.Comments.length; i++) {
              this.Comments[i].isExpanded =false;
            }
            //count of the Replies
            for (let i = 0; i < this.Comments.length; i++) {
              this.Comments[i].RepliesCount = this.Comments[i].Replies.length;
            }
           // this.totalComments = this.Comments.length;
            this.totalCommentOfPages = 0;
            if (this.Comments.length != 0) {
              this.totalCommentOfPages  = this.Comments[0].TotalComments;
            }
             this.Comment = "";
          })
        }
        else {
          this.alertService.error('Your Comments on Interview Questions has reached its limit today, please try again tomorrow');
        }
      });
    }
  }
  //GetAllCommentByQuestionId
  GetAllCommentByQuestionId(PKInterviewQuestionId: string, currentPageIndex:number) {
    this.interviewQuestionService.GetAllCommentsandVotesById(PKInterviewQuestionId, currentPageIndex,this.role).subscribe((result) => {
      this.Comments = result;
      const role = this.loginService.getRole();
      //if (role != "Admin") {
      //  this.Comments = this.Comments.filter(x => x.ReportCount < 4);
      //}
      for (let i = 0; i < this.Comments.length; i++) {
        this.Comments[i].isExpanded =false;
      }
      for (let i = 0; i < this.Comments.length; i++) {
        this.Comments[i].RepliesCount = this.Comments[i].Replies.length;
      }
      //this.totalComments = this.Comments.length;
      this.totalCommentOfPages = 0;
      if (this.Comments.length != 0) {
        this.totalCommentOfPages = this.Comments[0].TotalComments;
      }
     //console.log(this.Comments);
  });
  }
  getUserIdRole() {
    this.role = this.loginService.getRole();
    this.currentUserID = this.loginService.getCurrentUserId();
  }
  EditComment(comment: Comment) {
    this.oldComment = comment.Comment;
    comment.IsEdit = true;
  }
  deleteComment(deletePanel, comment: Comment) {
    this.deletecomment = comment;
    this.modalService.open(deletePanel, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => { result.result.then(() => { }, () => { }); })
  }
  Delete() {
    this.interviewQuestionService.DeleteComment(this.deletecomment.PKCommentId).subscribe((res) => {
      this.alertService.success("Your comment has successfully deleted");
      if (this.Comments.length == 1) {
        this.currentPageIndex--;
      }
      this.interviewQuestionService.GetAllCommentsandVotesById(this.deletecomment.FKInterviewQuestionId, this.currentPageIndex,this.role).subscribe((result) => {
        this.Comments = result;
        const role = this.loginService.getRole();
        //if (role != "Admin") {
        //  this.Comments = this.Comments.filter(x => x.ReportCount < 4);
        //}
        for (let i = 0; i < this.Comments.length; i++) {
          this.Comments[i].isExpanded =false;
        }
        //Count of the Replies
        for (let i = 0; i < this.Comments.length; i++) {
          this.Comments[i].RepliesCount = this.Comments[i].Replies.length;
        }
        //this.totalComments = this.Comments.length;
        this.totalCommentOfPages = 0;
        if (this.Comments.length != 0) {
          this.totalCommentOfPages = this.Comments[0].TotalComments;
        }
      })
    })
    this.modalService.dismissAll();
  }
  cancelDelete() {
    this.modalService.dismissAll();
  }
  UpdateComment(comment: Comment) {
    if (comment.Comment == this.oldComment) {
      return comment.IsEdit = false;
    }
    if (comment.Comment.length < 2) {
      return this.alertService.error('Your comment must be more than one character');
    }
    /*  this.editComment.Comment = comment.Comment;*/
    this.interviewQuestionService.UpdateComment(comment).subscribe((res) => {
      this.alertService.success("Your comment has been successfully updated");
      comment.IsEdit = false;
    })
  }
  Cancel(comment: Comment) {
    comment.Comment = this.oldComment;
    comment.IsEdit = false;
  }
  closeEdit() {
    this.isVisibleEditReply = -1;
  }

  //GetVotesTotalCountForComment(PkQuestionId: string, PKCommentId: string):number {
  //  this.interviewQuestionService.GetVotesTotalCountForComment(PkQuestionId, PKCommentId).subscribe((res) => {
  //    const votesForComment = res;
  //    this.totalVotesForComment = votesForComment.totalvotesforComment;
  //    console.log(votesForComment);
  //  })
  //  return this.totalVotesForComment;
  //}

  AddVotesforComment(data) {
   // console.log(data);
    this.userCommentVote.FkCommentId = data.PKCommentId;
    this.userCommentVote.FkQuestionId = data.FKInterviewQuestionId;
    this.userCommentVote.FkuserId = this.loginService.getCurrentUserId();
    this.userCommentVote.Vote = 1;
    this.userCommentVote.PkvoterId = "";
    this.interviewQuestionService.AddVotesforComment(this.userCommentVote).subscribe((res) => {
      if (res) {
        this.alertService.success("Voted successfuly");
        this.GetAllCommentByQuestionId(data.FKInterviewQuestionId, this.currentPageIndex);
      }
      else {
        this.alertService.warn("Only one vote allowed");
      }
    });
  }
  // method to show post comment design
  isShowPost(index:number) {
    this.isVisiblePostComment = index;
    this.replyComment = "";
  }
  isShowEditReply(index: number) {
    this.isVisibleEditReply = index;
    this.editCommentfield = "";
  }
  submitSubComment(form: NgForm,parentCommentId ) {
    if (form.value.replyComment.length < 2) {
      return this.alertService.error('Comment must be morethan one charecter')
    }
    let userName = this.loginService.getUserName();
    let currentUserId = this.loginService.getCurrentUserId();
    var comment = new CommentDTO();
    comment.Comment = form.value.replyComment;
    comment.FKInterviewQuestionId = this.PKInterviewQuestionId;
    comment.FKCommentedBy = currentUserId;
    comment.FkCommentedUser = userName;
    comment.IsExam = true;
    comment.ParentCommentId = parentCommentId;
    //console.log(comment);
    if (currentUserId != null) {
      this.interviewQuestionService.AddComment(comment).subscribe((res) => {
        if (res == 1) {
          //get service for sub comments
          this.alertService.success("Replied Successfully");
          this.isVisiblePostComment = -1;
          this.Comment = "";
          this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
        }
        else {
          this.alertService.error('Your Comments on Interview Questions has reached its limit today, please try again tomorrow');
        }
      });
    }
  }
  //GetListOfReplyByCommentId(ParentCommentId: string) {
  //  this.interviewQuestionService.GetListOfReplyByCommentId(ParentCommentId).subscribe((res) => {
  //    this.ReplyList = res;
  //    console.log(this.ReplyList);
  //  })
  //}

  toggleItem(index: number, PKCommentId:string) {
    this.Comments[index].isExpanded = !this.Comments[index].isExpanded;
    //this.interviewQuestionService.GetListOfReplyByCommentId(PKCommentId).subscribe((res) => {
    //  this.ReplyList = res;
      //console.log(this.ReplyList);
    //});
  }

  reportComment(commentId: string, FkCommentedUser: string) {
    if (this.role != "Admin") {
      this.commentId = commentId;
      this.commentedUser = FkCommentedUser ;
      setTimeout(function () {
        $("#reportForComment").modal('show');
      }, 600);
    }
  }

  AddUsersCommentReport() {
    const comments = this.Comments.filter(x => x.PKCommentId == this.commentId);
    const currentUserId = this.loginService.getCurrentUserId();
   // console.log(comments);
    this.usersCommentReport.fkCommentId = comments[0].PKCommentId;
    this.usersCommentReport.fkQuestionId = comments[0].FKInterviewQuestionId;
    this.usersCommentReport.fkuserId = currentUserId;
    this.usersCommentReport.pkReportId ="";
    this.usersCommentReport.reportCount = 1;
    this.interviewQuestionService.AddUsersCommentReport(this.usersCommentReport).subscribe(res => {
      if (res) {
        this.alertService.success("Reported successfully");
        $("#reportForComment").modal('hide');
      }
      else {
        this.alertService.warn("already Reported");
        $("#reportForComment").modal('hide');
      }
    });
  }

  paginationNext() {
    if (this.Comments[0].Pages > this.currentPageIndex && this.totalCommentOfPages > 5) {
       this.currentPageIndex++;
      }
  this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
  }
  paginationPrevious() {
    if (this.currentPageIndex > 1) {
      this.currentPageIndex--;
    }
    this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
  }
  GetVidoesLinkForQues(PKTestQuestionId: string) {
    this.testService.GetVidoesLinkForQues(PKTestQuestionId).subscribe((res) => {
      //console.log(res);
      this.currentQuestion.CourseURL = res["CourseURL"];
      this.currentQuestion.ThumbNailes = res["ThumbNailes"];
      //console.log(this.currentQuestion);
    })
  }
  //check network online or offline
  //checkNetworkStatus() {
  //  this.testService.checkNetworkStatus().subscribe((res) => {
  //    if (res) {
  //      this.isOfflineOronlineStatus = res;
  //    }
  //    console.log(this.isOfflineOronlineStatus);
  //  },
  //    (error) => {
  //      this.isOfflineOronlineStatus = false;
  //      console.log(this.isOfflineOronlineStatus);
  //    })
  //}
  onInputValueChanged(newValue: string) {
    // Remove leading and trailing whitespace
    const trimmedValue = newValue.trim();
    if (trimmedValue === '') {
      // If the value contains only whitespace, set it to an empty string
      this.replyComment = '';
      this.isThereWhitSpace = true;
    } else {
      // Otherwise, update the input value
      this.replyComment = trimmedValue;
      this.isThereWhitSpace = false;
    }       
  }

  onInputValueChangedComment(newValue: string) {
    // Remove leading and trailing whitespace
    const trimmedValue = newValue.trim();
    if (trimmedValue === '') {
      // If the value contains only whitespace, set it to an empty string
      this.Comment = '';
      this.isThereWhitSpace = true;
    } else {
      // Otherwise, update the input value
      this.Comment = trimmedValue;
      this.isThereWhitSpace = false;
    }
  }
  //Edit Reply
  editReply(replies: Comment) {
    replies.Comment = this.editCommentfield;
     this.interviewQuestionService.EditReply(replies).subscribe((res) => {
     this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
    })
    this.editCommentfield = "";
    this.isVisibleEditReply = -1;
  }
  deleteReply(PKCommentId: string) {
    this.interviewQuestionService.DeleteReply(PKCommentId).subscribe((res) => {
       this.GetAllCommentByQuestionId(this.PKInterviewQuestionId, this.currentPageIndex);
    })
  }


}


